import React from "react";

const CourseOutComeAiDs = () => {
  return (
    <div className="text-textGray">
      <h1 className="text-2xl font-semibold mb-2">
        Course Outcomes
      </h1>

      <p className="md:text-lg text-[14px] leading-7 text-justify mb-3">
        Through the unique initiatives of the Department of Artificial Intelligence and Data Science (AIDS), our students will be industry-ready, equipped with strong technical expertise in data analysis, machine learning, and statistical modelling, along with practical problem-solving abilities and essential soft skills.
        This approach ensures that graduates can handle real-world data challenges, derive meaningful insights, and make data-driven decisions. These efforts make students highly competitive in the job market and enable them to contribute effectively to the evolving demands of the data science and AI industry.
      
      </p>

     
    </div>
  );
};

export default CourseOutComeAiDs;